import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { startWith } from 'rxjs/operators';

export function subscribeToLangChange(
  translate: TranslateService,
  callback: () => void
): Subscription {
  return translate.onLangChange
    .pipe(startWith(translate.currentLang))
    .subscribe(() => callback());
}
